import React, { PureComponent, PropTypes } from 'react';
import classNames from 'classnames';

const defaultClazz = 'image';

const formatImageUrl = ({ src, defaultUrl }) => src ?
    src :
    defaultUrl;

class Image extends PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            url: formatImageUrl(props),
        };

        this.onError = this.onError.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            url: formatImageUrl(nextProps),
        });
    }

    onError() {
        this.setState((preState, props) => ({
            url: props.defaultUrl,
        }));
    }

    render() {
        const {
            url,
        } = this.state;

        const {
            className,
            defaultUrl,
        } = this.props;

        const clazz = classNames(
            defaultClazz, {
                [className]: !!className,
            }
        );

        const isDefaultUrl = url === defaultUrl;

        if (isDefaultUrl) {
            return (
                <img
                    className={clazz}
                    src={url}
                />
            );
        }

        return (
            <img
                className={clazz}
                src={url}
                onError={this.onError}
            />
        );
    }
}

Image.defaultProps = {
    defaultUrl: 'https://img.alicdn.com/tfs/TB1ZpaEpuuSBuNjy1XcXXcYjFXa-100-100.png',
};

if (process.env.NODE_ENV !== 'production') {  // eslint-disable-line
    Image.propTypes = {
        className: PropTypes.string,
        src: PropTypes.string,
        defaultUrl: PropTypes.string,
    };
}

export default Image;
